import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { phoneNumber, whatsappLink, siteInfo, cities } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-amber-600/30">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* À Propos */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                <span className="text-xl">🔮</span>
              </div>
              <h3 className="text-xl font-bold text-amber-400">Maître Spirituel</h3>
            </div>
            <p className="text-amber-100/70 text-sm leading-relaxed">
              Grand marabout africain sérieux et voyant médium reconnu. Plus de 25 ans d'expérience dans les rituels traditionnels africains.
            </p>
          </div>

          {/* Villes Principales */}
          <div>
            <h4 className="text-lg font-bold text-amber-400 mb-4">Nos Villes</h4>
            <ul className="space-y-2">
              {cities.slice(0, 8).map((city) => (
                <li key={city.id}>
                  <Link
                    to={`/${city.slug}`}
                    className="text-amber-100/70 hover:text-amber-400 transition-colors duration-300 text-sm flex items-center space-x-2"
                  >
                    <MapPin size={14} className="text-amber-500" />
                    <span>{city.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Rapides */}
          <div>
            <h4 className="text-lg font-bold text-amber-400 mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-amber-100/70">
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Retour Affectif</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Retour de l'Être Aimé</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Mariage</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Envoûtement</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Désenvoûtement</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Protection</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Voyance</li>
              <li>
                <Link to="/blog" className="hover:text-amber-400 transition-colors">
                  Blog & Articles
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-amber-400 mb-4">Contact</h4>
            <div className="space-y-4">
              <a
                href={`tel:${phoneNumber}`}
                className="flex items-center space-x-3 text-amber-100/70 hover:text-amber-400 transition-colors duration-300 group"
              >
                <div className="w-10 h-10 bg-red-600/20 rounded-full flex items-center justify-center group-hover:bg-red-600/40 transition-colors">
                  <Phone size={18} className="text-red-500" />
                </div>
                <span className="text-sm font-semibold">{phoneNumber}</span>
              </a>
              
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-amber-100/70 hover:text-green-400 transition-colors duration-300 group"
              >
                <div className="w-10 h-10 bg-green-600/20 rounded-full flex items-center justify-center group-hover:bg-green-600/40 transition-colors">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </div>
                <span className="text-sm font-semibold">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-600/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-amber-100/50 text-sm text-center md:text-left">
              © {currentYear} Marabout Africain Sérieux. Tous droits réservés.
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-amber-100/50">
              <a href="#" className="hover:text-amber-400 transition-colors">Mentions Légales</a>
              <a href="#" className="hover:text-amber-400 transition-colors">Confidentialité</a>
              <a href="#" className="hover:text-amber-400 transition-colors">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
